import { createI18nextInstance, useI18nextTranslation } from "@sg-protect/federation-runtime/i18n";
import type { I18nextKey, I18nextTFunction } from "@sg-protect/federation-runtime";
import type { ModuleRegisterFunction } from "@sg-protect/shell";
import { en } from "./en.ts";

declare module "@sg-protect/federation-runtime" {
    interface I18nextResources {
        odata: typeof en;
    }
}

const odataI18next = createI18nextInstance("odata", en, {
    fr: async () => (await import("./fr.ts")).fr,
    de: async () => (await import("./de.ts")).de,
    es: async () => (await import("./es.ts")).es,
    nl: async () => (await import("./nl.ts")).nl
});

export const registerODataI18next: ModuleRegisterFunction = runtime => {
    odataI18next.register(runtime);
};

export type ODataTFunction = I18nextTFunction<"odata">;

export type ODataTranslationKey = I18nextKey<"odata">;

export function useODataTranslation() {
    return useI18nextTranslation("odata", odataI18next.instance);
}
